// Fixed categories can use square brackets to embed extra data in the "tag" itself, such as organization IDs
const NAME_CHANGES = { Template: 'Photo templates', Invitation: 'Invitations' };
export default x => NAME_CHANGES[x] || (x || '').replace(/\[.*\]|@/, '');
